import { render, staticRenderFns } from "./ReportConfig.vue?vue&type=template&id=c865c672&scoped=true"
import script from "./ReportConfig.vue?vue&type=script&lang=js"
export * from "./ReportConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c865c672",
  null
  
)

export default component.exports